// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {SimUser} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {NotificationService, SimEventService, SimRecordingsService} from "@services";
import {Translations} from "@translations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_UpdateOwnershipDialogInput extends MatDialogDataBaseInput {
	//Depends on from which page open this component!
	type: "ScenarioRecording" | "Event";
	id: string;
	currentOwnerId: string;
}

export interface DialogData_UpdateOwnershipDialogOutput extends MatDialogDataBaseOutput {
	owner: SimUser;
	refreshNeeded: boolean;
}

@Component({
	selector: "sim-update-ownership-dialog",
	templateUrl: "./update-ownership-dialog.component.html",
	styleUrls: ["./update-ownership-dialog.component.scss"],
	standalone: false,
})
export class UpdateOwnershipDialogComponent extends BasicMaterialDialog<
	UpdateOwnershipDialogComponent,
	DialogData_UpdateOwnershipDialogInput,
	DialogData_UpdateOwnershipDialogOutput
> {
	T = Translations;
	selectedIndex = 0;
	addParticipantForm = new FormArray<FormControl<SimUser>>([]);
	currentOwnership: SimUser;
	hasOwnership: boolean = false;
	lastChangedUser: SimUser;

	constructor(
		_injector: Injector,
		private _simEventService: SimEventService,
		private _simNotificationService: NotificationService,
		public translate: TranslateService,
		private _simRecordingService: SimRecordingsService,
		private _eventService: SimEventService,
	) {
		super(_injector);
	}

	ngOnInit(): void {
		if (this.data.type === "ScenarioRecording") {
			this._simRecordingService.getRecordingById(this.data.id).then((result) => {
				this.currentOwnership = result.owner;
			});
		} else {
			this._eventService.getEventById(this.data.id).then((result) => {
				this.currentOwnership = result.owner;
			});
		}

		if (this.currentOwnership) this.hasOwnership = true;

		super.ngOnInit();
	}

	public addUser() {
		this.lastChangedUser = this.addParticipantForm.value[0];

		if (this.lastChangedUser) {
			this.hasOwnership = true;
		}
	}

	changeOwnership() {
		if (this.lastChangedUser) {
			const ownershipChanged = this.data.currentOwnerId !== this.lastChangedUser.id;
			if (this.data.type === "ScenarioRecording") {
				this._simRecordingService
					.updateOwnerOfScenarioRecording({
						scenarioRecordingId: this.data.id,
						ownerUserId: this.lastChangedUser.id,
						rootFolder: null,
					})
					.then((updateOwnerOfScenarioRecordingResult) => {
						if (updateOwnerOfScenarioRecordingResult) {
							this.close({
								action: "ok",
								owner: this.lastChangedUser,
								refreshNeeded: ownershipChanged,
							});
							this._simNotificationService.notifySuccess();
						} else {
							this._simNotificationService.notifyError(
								this.translate.instant(this.T.CHANGE_OWNERSHIP_DIALOG_COULD_NOT_CHANGE_OWNER),
							);
						}
					});
			} else {
				this._simEventService
					.updateOwnerOfEvent({
						eventId: this.data.id,
						ownerUserId: this.lastChangedUser.id,
					})
					.then(() => {
						this.close({
							action: "ok",
							owner: this.lastChangedUser,
							refreshNeeded: ownershipChanged,
						});
						this._simNotificationService.notifySuccess();
					})
					.catch((error) => {
						console.error(error);
						this._simNotificationService.notifyError(
							this.translate.instant(this.T.CHANGE_OWNERSHIP_DIALOG_COULD_NOT_CHANGE_OWNER),
						);
					});
			}
		}
	}
}
